import React, { useState } from 'react';
import { testimonialsData } from '../data/mock';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonialsData.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonialsData.length) % testimonialsData.length);
  };

  const currentTestimonial = testimonialsData[currentIndex];

  return (
    <section id="testimonials" className="py-20 md:py-28 bg-[#2C2C2C] relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#C9A962] rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#C9A962] rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-sans text-sm text-[#C9A962] tracking-[0.2em] uppercase mb-4 block">
            Testimonials
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4">
            What Our Clients Say
          </h2>
          <div className="w-16 h-0.5 bg-gradient-to-r from-transparent via-[#C9A962] to-transparent mx-auto" />
        </div>

        {/* Testimonial Card */}
        <div className="bg-[#3A3A3A] rounded-2xl p-8 md:p-12 relative">
          {/* Quote Icon */}
          <div className="absolute -top-6 left-8 md:left-12">
            <div className="w-12 h-12 rounded-full bg-[#C9A962] flex items-center justify-center">
              <Quote size={24} className="text-white" />
            </div>
          </div>

          {/* Content */}
          <div className="text-center pt-4">
            {/* Stars */}
            <div className="flex justify-center gap-1 mb-6">
              {[...Array(currentTestimonial.rating)].map((_, i) => (
                <Star key={i} size={20} className="text-[#C9A962] fill-[#C9A962]" />
              ))}
            </div>

            {/* Quote */}
            <p className="text-white/90 text-lg md:text-xl leading-relaxed mb-8 font-light italic">
              "{currentTestimonial.quote}"
            </p>

            {/* Author */}
            <div>
              <p className="font-serif text-[#C9A962] text-xl mb-1">
                {currentTestimonial.name}
              </p>
              <p className="text-white/60 text-sm tracking-wider uppercase">
                {currentTestimonial.event}
              </p>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex justify-center items-center gap-4 mt-10">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:border-[#C9A962] hover:text-[#C9A962] transition-colors"
              aria-label="Previous testimonial"
            >
              <ChevronLeft size={24} />
            </button>

            {/* Dots */}
            <div className="flex gap-2">
              {testimonialsData.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                    index === currentIndex
                      ? 'bg-[#C9A962] w-8'
                      : 'bg-white/30 hover:bg-white/50'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:border-[#C9A962] hover:text-[#C9A962] transition-colors"
              aria-label="Next testimonial"
            >
              <ChevronRight size={24} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
